import { render, staticRenderFns } from "./user_play_count.vue?vue&type=template&id=304b4888&"
import script from "./user_play_count.vue?vue&type=script&lang=ts&"
export * from "./user_play_count.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports